import React, { useState } from 'react';
import { Drawer, List, ListItemText, ListItemIcon, ListItemButton, Toolbar, Box, Collapse } from '@mui/material';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import HomeIcon from '@mui/icons-material/Home';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useLocation, useNavigate } from 'react-router-dom';

const menuItems = [
    { text: 'Dashboard', icon: <HomeIcon />, path: '/admin/dashboard' },
    { text: 'Bookings', icon: <BookOnlineIcon />, path: '/admin/bookings' },
];

const Sidebar = ({ drawerWidth, mobileOpen, handleDrawerToggle }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [openDropdown, setOpenDropdown] = useState({});

    const handleDropdownClick = (text) => {
        setOpenDropdown((prev) => ({ ...prev, [text]: !prev[text] }));
    };

    const handleNavigation = (path) => {
        navigate(path);
    };

    const drawerContent = (
        <div>
            <Toolbar />
            <Box sx={{ overflow: 'auto', mt: 1 }}>
                <List>
                    {menuItems.map((item) => {
                        const isActive = location.pathname.startsWith(item.path);

                        return (
                            <React.Fragment key={item.text}>
                                <ListItemButton
                                    onClick={() => item.isExpandable ? handleDropdownClick(item.text) : handleNavigation(item.path)}
                                    className={isActive && !item.isExpandable ? 'active' : ''}
                                >
                                    <ListItemIcon>
                                        {item.icon}
                                    </ListItemIcon>
                                    <ListItemText primary={item.text} />
                                    {item.isExpandable ? (openDropdown[item.text] ? <ExpandLess /> : <ExpandMore />) : null}
                                </ListItemButton>
                                {item.isExpandable && (
                                    <Collapse in={openDropdown[item.text]} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            <ListItemButton sx={{ pl: 4 }}>
                                                <ListItemText primary={`Manage ${item.text}`} />
                                            </ListItemButton>
                                        </List>
                                    </Collapse>
                                )}
                            </React.Fragment>
                        );
                    })}
                </List>
            </Box>
        </div>
    );

    return (
        <Box
            component="nav"
            sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
            aria-label="mailbox folders"
        >
            <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true,
                }}
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }}
            >
                {drawerContent}
            </Drawer>
            <Drawer
                variant="permanent"
                sx={{
                    display: { xs: 'none', sm: 'block' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }}
                open
            >
                {drawerContent}
            </Drawer>
        </Box>
    );
};

export default Sidebar;
